import { useEffect, useState } from "react";

/** Zwalnia adres pliku po zmianie podglądu albo opuszczeniu strony. */
export default function useObjectUrl(blob) {
  const [file, setFile] = useState(null);
  useEffect(() => {
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    setFile({ blob, url });
    return () => URL.revokeObjectURL(url);
  }, [blob]);
  return file?.blob === blob ? file?.url : "";
}
